module.exports = __webpack_public_path__ + "static/media/back-new-6.f74d511c.jpg";